import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-cs-range',
  templateUrl: './cs-range.component.html',
  styleUrls: [],
  standalone: false
})
export class CsRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
